import { currencyOptions } from '../resources/static';

const getCurrencySign = (value) => {
    const currency = currencyOptions.find((option) => option.value === value);
    return currency ? currency.sign : null;
};

export default getCurrencySign;
